import { Tool } from './Tool'
export class TranslateTool extends Tool {
    public removeInteractions(): void {
    }

    public addInteractions(): void {
    }
}
